import { connect } from 'react-redux'
import StationUserTable from '../../components/station-user/StationUserTable'
import { fetchStationUserList } from '../../state/actions/station-user'
import { IStoreState, IStationUserSearchObject, IStationUserFilters } from '../../types'
import { moveToArchive } from '../../state/actions/station-user/index'
import { getAllOrganizations } from '../../state/actions/organizations'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    currentOrgId: state.organizations.currentOrgId,
    isFetching: state.stationUser.isFetching,
    stationUser: Object.values(state.stationUser.items).filter(
      o => o.organizationId === state.organizations.currentOrgId
    ),
    total: state.stationUser.total,
    type: ownProps.type
  }
}

const mapDispatchToProps = (dispatch: any, props: any) => {
  return {
    fetchOrgList: () => {
      return dispatch(getAllOrganizations())
    },
    fetchStationUserList: (filters: IStationUserFilters) => {
      return dispatch(fetchStationUserList(filters))
    },
    archiveStationUser: (teamMember: IStationUserSearchObject) => {
      return dispatch(moveToArchive(teamMember))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StationUserTable)



// WEBPACK FOOTER //
// ./src/containers/station-user/StationUserTable.ts